import { connect } from 'react-redux';
import ModalDialog from './ModalDialog';

const mapStateToProps = ({ modalDialog }) => ({
    ...modalDialog
});

export default connect(
    mapStateToProps,
)(ModalDialog);



// WEBPACK FOOTER //
// ./src/blocks/modal-dialog/index.js